import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const initiativesFields = [
  "gaming_initiativesid", // UID
  "gaming_name", // Text
  "gaming_programtracking", // Boolean
  "createdon", // Date
  "modifiedby", // Lookup - User
  "modifiedon", // Date
] as const;

export const initiativesReferences: EntityReferences<EntityName.gaming_initiatives> = {
  [EntityName.user]: ["modifiedby"],
};

export const initiativesKey: AnyEntityField<EntityName.gaming_initiatives> = "gaming_initiativesid";
